export default {
  install: function(Vue, options) {
    Vue.mixin({
      computed: {
        isDevelopment() {
          return process.env.NODE_ENV === 'development'
        },
        isMobile() {
          return options ? options.isMobile : undefined;
        },
        isAndroid() {
          return options ? options.isAndroid: undefined
        },
        isMobileOnly() {
          return options ? options.isMobileOnly: undefined
        },
        isSafari() {
          return options ? options.isSafari: undefined
        },
        isCliniusCh() {
          return process.env.VUE_APP_CLINIUS_CH === '1'
        },
        isCliniusDe() {
          return process.env.VUE_APP_CLINIUS_CH === '0'
        },
        appId() {
          return process.env.VUE_APP_ID;
        }
      }
    })
  }
}
